import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubPlanAssociationsComponent } from './sub-plan-associations.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';
import {TableModule} from '../../../../tinea-components/table/table.module';
import {PagingModule} from '../../../../tinea-components/paging/paging.module';



@NgModule({
  declarations: [SubPlanAssociationsComponent],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        TranslatePipe, TranslateDirective,
        TableModule,
        PagingModule
    ],
  exports: [
    SubPlanAssociationsComponent
  ]
})
export class SubPlanAssociationsModule { }
